document.addEventListener('DOMContentLoaded', function () {
  console.log('Calculate Shipping Button script loaded.');
  var e = document.getElementById('CalculateShippingBtn');
  e &&
    e.addEventListener('click', function (e) {
      (console.log('Calculate Shipping Button clicked.'), e.preventDefault());
      var t = document.querySelector('.tab-title-btn[data-tab="delivery"]');
      if ((console.log('Tab button found:', t), !t)) return;
      (t.click(),
        setTimeout(function () {
          var e = document.querySelector('.tab-content[data-tab="delivery"]');
          e && e.scrollIntoView({ behavior: 'smooth' });
        }, 100));
    });
});
